<template>
  <div>
    <section>
      <v-img
        :src="require('@/assets/banner.png')"
        alt="Logo do Sistema"
        height="800"
      />
    </section>


    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center
        text-xs-center
      >
        <v-flex
          xs12
          sm9
          md6
          lg4
          xl4
        >
          <v-progress-circular
            v-if="loading"
            indeterminate
            :size="120"
            :width="6"
            color="secondary"
          />
          <v-container
            v-else
            grid-list-xl
          >
            <v-layout
              justify-center
              wrap
            >
            <v-flex
                v-if="isFaseFinalizada(periodoVotacao.dh_fim)"
                xs12
              >
                <v-card
                  class="elevation-15 transparent"
                  style="max-width:1074px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      color="success"
                    >
                      star
                    </v-icon>
                    <v-icon
                      x-large
                      color="warning"
                    >
                      star
                    </v-icon>
                  </v-card-text>
                  <v-card-title>
                    <v-flex headline>
                      Representantes Regionais
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    O Resultado da Votação para eleger os representantes regionais da sociedade civil já está disponível!
                  </v-card-text>
                  <v-flex
                    class="mt-1"
                    justify-center
                  >
                    <v-btn
                      color="primary"
                      to="/votacao/resultado"
                      dark
                      block
                    >
                    Clique aqui para acessar o resultado
                      <!-- <v-icon right color="white">
                        call_made
                      </v-icon> -->
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-flex>
            <v-flex
                v-if="ativarListaFinalIndicadosOrganizacao"
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-1"
                  >
                    <v-flex headline>
                      Lista Final de Indicados das Organizações 
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Consulte aqui a lista final de Indicações das Organizações e Entidades Culturais.
                  </v-card-text>
                  <v-flex
                    class="mt-4"
                    justify-center
                  >
                    <v-btn
                      color="green darken-4"
                      to="indicacao/organizacao/lista-final-habilitados"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-flex>
            <v-flex
                v-if="!isFaseFinalizada(periodoVotacao.dh_fim)"
                xs12
                sm12
                md7
                lg7
                xl7
              >
                <v-card
                  class="elevation-15 transparent"
                  style="max-width:600px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                    >
                      move_to_inbox
                    </v-icon>
                  </v-card-text>
                  <v-card-title>
                    <v-flex headline>
                      Votação - Indicados dos Conselhos de Cultura
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    <span v-if="$vuetify.breakpoint.mdAndUp">Participe da votação para eleger os representantes regionais da sociedade civil para o mandato 2022/2025 do Conselho Nacional de Política Cultural - CNPC.</span>
                    Participe, Cadastre-se e Vote!
                    Votação aberta de {{ this.periodoVotacao.dh_inicio | formatDate }} a {{ this.periodoVotacao.dh_fim | formatDate }}.
                  </v-card-text>
                  <v-flex
                    class="mt-1"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarPeriodoVotacao"
                      color="green darken-4"
                      to="/votacao"
                      dark
                      large
                    >
                      <v-icon color="white">
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="white--text"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

            <v-flex
                v-if="!isFaseFinalizada(periodoVotacao.dh_fim)"
                xs12
                sm12
                md6
                lg5
                xl5
              >
                <v-card
                  class="elevation-15 transparent"
                  style="max-width:400px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                    >
                      thumbs_up_down
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex headline>
                      Inscrição do Eleitor
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Cadastre-se e vote em um representante para a sua região. Inscrição de eleitor aberta até {{ this.faseInscricaoEleitor.dh_fim | formatDate }}.
                  </v-card-text>
                  <v-flex
                    class="mt-3"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarInscricaoEleitor"
                      color="green darken-4"
                      to="/eleitor/inscricao"
                      dark
                      large
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

            <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                    contacts
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-2"
                  >
                    <v-flex
                      headline
                      pt-0
                    >
                      Ajuste da Indicação das Organizações - Segunda Convocação
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    Período de ajuste da indicação de Organizações e Entidades Culturais classificadas na segunda convocação de {{ this.faseAjusteIndicacaoOrganizacaoSegundaConvocacao.dh_inicio | formatDate }} a {{ this.faseAjusteIndicacaoOrganizacaoSegundaConvocacao.dh_fim | formatDate }}.
                  </v-card-text>
                  <v-flex
                    class="pt-0"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarAjusteIndicacaoOrganizacaoSegundaConvocacao"
                      color="green darken-4"
                      to="/organizacao/indicacao/ajuste"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px; height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      people
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-0"
                  >
                    <v-flex headline>
                      Indicação das Organizações - Segunda Convocação
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    A Segunda Convocação da Indicação de Titulares e Suplentes das Organizações e Entidades culturais ocorrerá de {{ this.faseIndicacaoOrganizacaoSegundaConvocacao.dh_inicio | formatDate }} a {{ this.faseIndicacaoOrganizacaoSegundaConvocacao.dh_fim | formatDate }}
                  </v-card-text>
                  <v-flex
                    class="pt-0"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarIndicacaoOrganizacaoSegundaConvocacao"
                      color="green darken-4"
                      to="/organizacao/indicacao"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

            
            <v-flex
                v-if="ativarListaFinalIndicadosConselho"
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-1"
                  >
                    <v-flex headline>
                      Lista Final de Indicados dos Conselhos 
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Consulte aqui a lista final de Indicações dos Conselhos de Cultura.
                  </v-card-text>
                  <v-flex
                    class="mt-4"
                    justify-center
                  >
                    <v-btn
                      color="green darken-4"
                      to="indicacao/conselho/lista-final-habilitados"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-flex>

                        <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                    contacts
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex
                      headline
                      pt-0
                    >
                      Ajuste da Indicação das Organizações
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    Período de ajuste da indicação de Organizações e Entidades Culturais de {{ this.faseAjusteIndicacaoOrganizacao.dh_inicio | formatDate }} a {{ this.faseAjusteIndicacaoOrganizacao.dh_fim | formatDate }}.
                  </v-card-text>
                  <v-flex
                    class="pt-1"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarAjusteIndicacaoOrganizacao"
                      color="green darken-4"
                      to="/organizacao/indicacao/ajuste"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

            <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      gavel
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex
                      headline
                      pt-0
                    >
                      Recurso da Indicação dos Conselhos
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    Período de recurso da indicação de Conselhos de Cultura de {{ this.faseRecursoIndicacaoConselho.dh_inicio | formatDate }} a {{ this.faseRecursoIndicacaoConselho.dh_fim | formatDate }}.
                  </v-card-text>
                  <v-flex
                    class="pt-1"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarRecursoIndicacaoConselho"
                      color="green darken-4"
                      to="/recurso/indicacao/conselho"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
            </v-flex>

            <v-flex
                v-if="ativarListaParcialIndicadosConselho || ativarListaParcialIndicadosOrganizacao"
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex headline>
                      Lista Parcial de Indicados 
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Consulte aqui a lista parcial de indicados.
                  </v-card-text>
                  <v-flex
                    class="mt-2"
                    justify-center
                  >
                    <v-btn
                      color="green darken-4"
                      to="/indicacao/lista"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-flex>
            
            <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px; height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      people
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-0"
                  >
                    <v-flex headline>
                      Indicação dos Conselhos
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-1">
                    A fase de Indicação dos Representantes de Conselhos de Cultura ocorrerá de {{ this.faseIndicacaoConselho.dh_inicio | formatDate }} a {{ this.faseIndicacaoConselho.dh_fim | formatDate }}
                  </v-card-text>
                  <v-flex
                    class="mt-2"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarIndicacaoConselho"
                      color="green darken-4"
                      to="/conselho/indicacao"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px; height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      people
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-0"
                  >
                    <v-flex headline>
                      Indicação das Organizações
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    A fase de Indicação dos Titulares e Suplentes das Organizações e Entidades culturais ocorrerá de {{ this.faseIndicacaoOrganizacao.dh_inicio | formatDate }} a {{ this.faseIndicacaoOrganizacao.dh_fim | formatDate }}
                  </v-card-text>
                  <v-flex
                    class="mt-0"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarIndicacaoOrganizacao"
                      color="green darken-4"
                      to="/organizacao/indicacao"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>


            <v-flex
                v-if="ativarListaFinalHabilitados"
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-1"
                  >
                    <v-flex headline>
                      Lista Final de Habilitados
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Consulte aqui a lista final de Habilitados.
                  </v-card-text>
                  <v-flex
                    class="mt-4"
                    justify-center
                  >
                    <v-btn
                      color="green darken-4"
                      to="/habilitacao/lista-final-habilitados"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      gavel
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex
                      headline
                      pt-2
                    >
                      Recurso habilitação
                    </v-flex>
                  </v-card-title>
                  <v-card-text pt-0>
                    Período de recurso da habilitação de Organização ou Entidade Cultural e Conselhos de {{ this.faseRecursoHabilitacao.dh_inicio | formatDate }} a {{ this.faseRecursoHabilitacao.dh_fim | formatDate }}.
                  </v-card-text>
                  <v-flex
                    class="mt-1"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarRecursoHabilitacaoConselho || ativarRecursoHabilitacaoOrganizacao"
                      color="green darken-4"
                      :to="'/recurso/habilitacao/'+perfil.no_perfil"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

              <v-flex
                v-if="ativarListaParcialHabilitadosConselho || ativarListaParcialHabilitadosOrganizacao"
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex headline>
                      Lista Parcial de Habilitados
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Consulte aqui a lista parcial de habilitados.
                  </v-card-text>
                  <v-flex
                    class="mt-2"
                    justify-center
                  >
                    <v-btn
                      color="green darken-4"
                      to="/habilitacao/lista-parcial-habilitados"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-flex>


              <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      content_paste
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex
                      headline
                      pt-2
                    >
                      Habilitação dos Inscritos
                    </v-flex>
                  </v-card-title>
                  <v-card-text pt-0>
                    A análise da Habilitação dos Conselhos de Cultura, Organizações e Entidades Culturais ocorrerá de {{ this.faseHabilitacao.dh_inicio | formatDate }} a {{ this.faseHabilitacao.dh_fim | formatDate }}.
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex
                v-if="ativarListaFinalInscritos"
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex headline>
                      Lista Final de Inscritos
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Consulte aqui a lista final de inscritos.
                  </v-card-text>
                  <v-flex
                    class="mt-5"
                    justify-center
                  >
                    <v-btn
                      color="green darken-4"
                      to="/inscricao/lista-final-inscritos"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      gavel
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex
                      headline
                      pt-2
                    >
                      Recurso Inscrição
                    </v-flex>
                  </v-card-title>
                  <v-card-text pt-0>
                    Período de recurso da inscrição de Organização ou Entidade Cultural e Conselhos de {{ this.faseRecursoInscricao.dh_inicio | formatDate }} a {{ this.faseRecursoInscricao.dh_fim | formatDate }}.
                  </v-card-text>
                  <v-flex
                    class="mt-1"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarRecursoInscricaoConselho || ativarRecursoInscricaoOrganizacao"
                      color="green darken-4"
                      to="/recurso/inscricao"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-flex
                v-if="ativarListaParcialInscritosConselho || ativarListaParcialInscritosOrganizacao"
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px;height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex headline>
                      Lista parcial de inscritos
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Consulte aqui a lista parcial de inscritos.
                  </v-card-text>
                  <v-flex
                    class="mt-5"
                    justify-center
                  >
                    <v-btn
                      color="green darken-4"
                      to="/inscricao/lista-parcial"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px; height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-2"
                  >
                    <v-flex headline>
                      Inscrição do Conselho de Cultura
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    Inscreva o conselho de cultura no período de {{ this.faseInscricaoConselho.dh_inicio | formatDate }} a {{ this.faseInscricaoConselho.dh_fim | formatDate }} para participar do processo de seleção.
                  </v-card-text>
                  <v-flex
                    class="mt-1"
                    wrap
                    align-center
                    justify-center
                  >
                    <v-btn
                      v-if="ativarInscricaoConselho"
                      color="green darken-4"
                      to="/conselho/inscricao"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else-if="dataAtual < faseInscricaoConselho.dh_inicio"
                      class="text--secondary"
                    >
                      As Inscrições serão abertas a partir do dia {{ this.faseInscricaoConselho.dh_inicio | formatDate }}
                    </v-card-text>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px; height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      list
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center pt-0"
                  >
                    <v-flex headline>
                      Inscrição da Organização ou Entidade Cultural
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    Inscreva a sua organização ou entidade no período de {{ this.faseInscricaoOrganizacao.dh_inicio | formatDate }} a {{ this.faseInscricaoOrganizacao.dh_fim | formatDate }} para participar do processo de seleção.
                  </v-card-text>
                  <v-flex
                    class="mt-0"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarInscricaoOrganizacao"
                      color="green darken-4"
                      to="/organizacao/inscricao"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>
                    <v-card-text
                      v-else-if="dataAtual < faseInscricaoOrganizacao.dh_inicio"
                      class="text--secondary"
                    >
                      As Inscrições serão abertas a partir do dia {{ this.faseInscricaoOrganizacao.dh_inicio | formatDate }}
                    </v-card-text>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                sm9
                md6
                lg4
                xl4
              >
                <v-card
                  class="elevation-15 transparent"
                  style="width:300px; height: 380px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon
                      x-large
                      class="text--lighten-2"
                    >
                      thumbs_up_down
                    </v-icon>
                  </v-card-text>
                  <v-card-title
                    primary-title
                    class="layout justify-center"
                  >
                    <v-flex headline>
                      Inscrição do Eleitor
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    Período de inscrição de {{ this.faseInscricaoEleitor.dh_inicio | formatDate }} a  {{ this.faseInscricaoEleitor.dh_fim | formatDate }} e Período de votação de {{ this.periodoVotacao.dh_inicio | formatDate }} a {{ this.periodoVotacao.dh_fim | formatDate }}
                  </v-card-text>
                  <v-flex
                    class="mt-3"
                    justify-center
                  >
                    <v-btn
                      v-if="ativarInscricaoEleitor"
                      color="green darken-4"
                      to="/eleitor/inscricao"
                      dark
                    >
                      <v-icon>
                        call_made
                      </v-icon>
                    </v-btn>

                    <v-card-text
                      v-else-if="dataAtual < faseInscricaoEleitor.dh_inicio"
                      class="text--secondary"
                    >
                      As Inscrições serão abertas a partir do dia {{ this.faseInscricaoEleitor.dh_inicio | formatDate }}
                    </v-card-text>
                    <v-card-text
                      v-else
                      class="text--secondary"
                    >
                      Fase Indisponível
                    </v-card-text>
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-parallax
        :src="require('@/assets/banner_2.jpg')"
        height="500"
      >
        <v-layout
          column
          align-center
          justify-center
          row
          fill-height
        >
          <v-layout
            row
            align-center
            justify-center
          >
            <v-flex>
              <v-btn
                class="yellow darken-4 mt-5 white--text"
                dark
                large
                target="_blank"
                href="http://cnpc.cultura.gov.br/edital-de-selecao-publica-dos-representantes-sociedade-civil-mandato-20222025/"
              >
                Acesse o Edital
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn
                class="yellow darken-4 mt-5 white--text"
                dark
                large
                target="_blank"
                href="http://cnpc.cultura.gov.br/2022/08/01/manuais-de-orientacoes/"
              >
                Acesse os Manuais de Orientações
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout
          row
          wrap
          justify-center
          class="my-5"
        >
          <v-flex
            xs12
            sm5
          >
            <v-card class="elevation-0 transparent">
              <v-card-title
                primary-title
                class="layout justify-center"
              >
                <div class="headline">
                  O que é Conselho Nacional de Política Cultural?
                </div>
              </v-card-title>
              <v-card-text>
                O Conselho Nacional de Política Cultural (CNPC) é um órgão colegiado integrante da
                estrutura da Secretaria Especial da Cultura do Ministério do Turismo.
                Esse órgão tem como finalidade propor a formulação de políticas públicas,
                promovendo a articulação e o debate dos diferentes níveis de governo e a sociedade
                civil organizada, para o desenvolvimento e fomento das atividades culturais no
                território nacional.
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            sm5
            offset-sm1
          >
            <v-card class="elevation-0 transparent">
              <v-card-title
                primary-title
                class="layout justify-center"
              >
                <div class="headline">
                  Fale Conosco
                </div>
              </v-card-title>
              <v-card-text>
                Esclarecimentos e informações complementares necessários à aplicação dos termos
                deste Edital poderão ser obtidos junto ao Departamento do Sistema Nacional de Cultura:
              </v-card-text>
              <v-list class="transparent">
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="text--lighten-2">
                      phone
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      (61) 2024-2026
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="text--lighten-2">
                      mail
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <a
                        href="mailto:votacultura@turismo.gov.br"
                        target="_blank"
                      >votacultura@turismo.gov.br</a>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import codigosFase from '../../fase/utils/codigosFase';

export default {
  data: () => ({
    codigosFase,
    loading: false,
    isFaseRecursoHabilitacao: false,

    dataAtual: moment().toDate().getTime(),

    faseInscricaoConselho: {},
    faseInscricaoOrganizacao: {},
    faseInscricaoEleitor: {},
    faseRecursoInscricao: {},
    faseHabilitacao: {},
    faseRecursoHabilitacao: {},
    faseIndicacaoConselho: {},
    faseIndicacaoOrganizacao: {},
    faseRecursoIndicacaoConselho: {},
    faseAjusteIndicacaoOrganizacao: {},
    faseIndicacaoOrganizacaoSegundaConvocacao: {},
    faseAjusteIndicacaoOrganizacaoSegundaConvocacao: {},
    periodoVotacao: {},
  }),
  computed: {
    ...mapGetters({
      ativarFasePreInscricao: 'fase/ativarFasePreInscricao',

      ativarInscricaoConselho: 'fase/ativarInscricaoConselho',
      ativarInscricaoOrganizacao: 'fase/ativarInscricaoOrganizacao',
      ativarInscricaoEleitor: 'fase/ativarInscricaoEleitor',

      ativarListaParcialInscritosConselho: 'fase/ativarListaParcialInscritosConselho',
      ativarListaParcialInscritosOrganizacao: 'fase/ativarListaParcialInscritosOrganizacao',

      ativarRecursoInscricaoConselho: 'fase/ativarRecursoInscricaoConselho',
      ativarRecursoInscricaoOrganizacao: 'fase/ativarRecursoInscricaoOrganizacao',

      ativarListaFinalInscritos: 'fase/ativarListaFinalInscritos',

      ativarHabilitacaoConselho: 'fase/ativarHabilitacaoConselho',
      ativarHabilitacaoOrganizacao: 'fase/ativarHabilitacaoOrganizacao',

      ativarListaParcialHabilitadosConselho: 'fase/ativarListaParcialHabilitadosConselho',
      ativarListaParcialHabilitadosOrganizacao: 'fase/ativarListaParcialHabilitadosOrganizacao',

      ativarRecursoHabilitacaoConselho: 'fase/ativarRecursoHabilitacaoConselho',
      ativarRecursoHabilitacaoOrganizacao: 'fase/ativarRecursoHabilitacaoOrganizacao',

      ativarListaFinalHabilitados: 'fase/ativarListaFinalHabilitados',

      ativarIndicacaoConselho: 'fase/ativarIndicacaoConselho',
      ativarIndicacaoOrganizacao: 'fase/ativarIndicacaoOrganizacao',

      ativarListaParcialIndicadosConselho: 'fase/ativarListaParcialIndicadosConselho',
      ativarListaParcialIndicadosOrganizacao: 'fase/ativarListaParcialIndicadosOrganizacao',

      ativarRecursoIndicacaoConselho: 'fase/ativarRecursoIndicacaoConselho',
      ativarAjusteIndicacaoOrganizacao: 'fase/ativarAjusteIndicacaoOrganizacao',
      
      ativarIndicacaoOrganizacaoSegundaConvocacao: 'fase/ativarIndicacaoOrganizacaoSegundaConvocacao',
      ativarAjusteIndicacaoOrganizacaoSegundaConvocacao: 'fase/ativarAjusteIndicacaoOrganizacaoSegundaConvocacao',

      ativarListaFinalIndicadosConselho: 'fase/ativarListaFinalIndicadosConselho',
      ativarListaFinalIndicadosOrganizacao: 'fase/ativarListaFinalIndicadosOrganizacao',

      ativarPeriodoVotacao: 'fase/ativarPeriodoVotacao',

      fases: 'fase/fases',
      perfil: 'conta/perfil',
      usuario: 'conta/usuario',
    }),
  },
  watch: {
    fases() {
      this.resolveFases();
    },
  },
  mounted() {
    this.loading = true;
    this.obterUsuarioLogado();
    if (this.fases && this.fases.length > 0) {
      this.resolveFases();
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
  methods: {
    ...mapActions({
      obterUsuarioLogado: 'conta/tratarUsuarioLogado',
    }),
    resolveFases() {
      this.buildFases();
      this.loading = false;
    },
    isFaseFinalizada(dh_fim){
      return this.dataAtual > moment(dh_fim).toDate().getTime();
    },
    buildFases() {
      this.fasePreInscricao = this.fases.find(f => f.tp_fase == codigosFase.TP_PRE_INSCRICAO);
      this.faseInscricaoConselho = this.fases.find(f => f.tp_fase == codigosFase.TP_ABERTURA_INSCRICOES_CONSELHO);
      this.faseInscricaoOrganizacao = this.fases.find(f => f.tp_fase == codigosFase.TP_ABERTURA_INSCRICOES_ORGANIZACAO);
      this.faseInscricaoEleitor = this.fases.find(f => f.tp_fase == codigosFase.TP_ABERTURA_INSCRICOES_ELEITOR);

      this.faseRecursoInscricao = this.fases.find(f => f.tp_fase == codigosFase.TP_RECURSO_INSCRICOES_CONSELHO);

      this.faseHabilitacao = this.fases.find(f => f.tp_fase == codigosFase.TP_HABILITACAO_CONSELHO);

      this.faseRecursoHabilitacao = this.fases.find(f => f.tp_fase == codigosFase.TP_RECURSO_HABILITACAO_CONSELHO);

      this.faseIndicacaoConselho = this.fases.find(f => f.tp_fase == codigosFase.TP_INDICACAO_CONSELHO);
      this.faseIndicacaoOrganizacao = this.fases.find(f => f.tp_fase == codigosFase.TP_INDICACAO_ORGANIZACAO);
      
      this.faseRecursoIndicacaoConselho = this.fases.find(f => f.tp_fase == codigosFase.TP_RECURSO_INDICACAO_CONSELHO);
      this.faseAjusteIndicacaoOrganizacao = this.fases.find(f => f.tp_fase == codigosFase.TP_AJUSTE_INDICACAO_ORGANIZACAO);
      
      this.faseIndicacaoOrganizacaoSegundaConvocacao = this.fases.find(f => f.tp_fase == codigosFase.TP_INDICACAO_ORGANIZACAO_SEGUNDA_CONVOCACAO);
      this.faseAjusteIndicacaoOrganizacaoSegundaConvocacao = this.fases.find(f => f.tp_fase == codigosFase.TP_AJUSTE_INDICACAO_ORGANIZACAO_SEGUNDA_CONVOCACAO);

      this.periodoVotacao = this.fases.find(f => f.tp_fase == codigosFase.TP_PERIODO_VOTACAO);
    },
  },
};
</script>
